<template>
  <div class="w-full h-full">
    <StudentsTable />
  </div>
</template>
<script>
  import Vue from 'vue';
  import onlineRoundtableSockets from 'mixins/sockets/onlineRoundtableSocketEvents';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';
  export default Vue.extend({
    components: {
      StudentsTable: () =>
        import(
          '../../onlineRoundtables/components/summaryComponents/StudentsTable.vue'
        ),
    },
    mixins: [onlineRoundtableSockets, courseSocketMixin],
    mounted() {
      const { courseID, roundtableID } = this.$route.params;
      this.setupCourseSocket(courseID);
      this.leaveRoundtableSocket(roundtableID);
      this.setupRoundtableSocket(roundtableID);
    },
    beforeDestroy() {
      this.leaveRoundtableSocket(this.$route.params.roundtableID);
    },
  });
</script>



// WEBPACK FOOTER //
// IndividualSummary.vue?dd0adec4